export var getIsDisabledState = (disabledState, widgetInternalDisabledState) => {
  return disabledState || widgetInternalDisabledState;
};
export var getSubHeading = (subHeading, fullName, date, guardianName) => {
  if (subHeading) {
    return subHeading;
  }
  return fullName && date && guardianName ? fullName + " \u2022 " + date + " \u2022 " + guardianName : '';
};
export var getDate = function getDate(date, format) {
  if (format === void 0) {
    format = 'dd-mm-yyyy';
  }
  var day = String(date.getDate()).padStart(2, '0');
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var year = date.getFullYear();
  if (format === 'dd-mm-yyyy') {
    return day + "-" + month + "-" + year;
  } else if (format === 'dd MMM yyyy') {
    var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return day + " " + monthNames[date.getMonth()] + " " + year;
  }
};
export var parseDate = dateStr => {
  if (!dateStr) return new Date();
  var parts = dateStr.split('-');
  if (parts.length === 1) return new Date(+parts[0], 0, 1);
  if (parts.length === 3) return new Date(+parts[2], +parts[1] - 1, +parts[0]);
};